import { render, staticRenderFns } from "./ProgramElement.vue?vue&type=template&id=a08f711a&"
import script from "./ProgramElement.vue?vue&type=script&lang=js&"
export * from "./ProgramElement.vue?vue&type=script&lang=js&"
import style0 from "./ProgramElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports